import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeaturedProductsComponent } from './featured-products.component';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { TitleCasePipe } from '../pipes/title-case.pipe';
import { SharedModule } from '../common/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FeaturedProductsModal } from './featured-products-modal/featured-products-modal';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { RouterModule } from '@angular/router';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { ComponentsModule } from '../components/components.module';
import { DragScrollModule } from 'ngx-drag-scroll';

@NgModule({
  declarations: [FeaturedProductsComponent, TitleCasePipe, FeaturedProductsModal],
  imports: [
    CommonModule,
    MatCardModule,
    MatGridListModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatButtonToggleModule,
    RouterModule,
    NgxGoogleAnalyticsModule,
    ComponentsModule,
    DragScrollModule,
  ],
})
export class FeaturedProductsModule {}
